import { initSplideCarousel } from "../../util/carousel";
function init() {
  const sliders = document.querySelectorAll(".js-vertical-carousel") as NodeListOf<HTMLElement>;

  for (const slider of sliders) {
    initSplideCarousel(slider, {
      perPage: 3,
      arrows: false,
      width: "100%",
      height: "100vh",
      fixedHeight: "fit-content",
      direction: "ttb",
      paginationDirection: "ttb",
      destroy: true,
      type: "loop",
      breakpoints: {
        768: {
          destroy: false
        },
      },
    });
  }
}

export default init;
